import { FC } from "react";
import { GridApi } from "ag-grid-community";
import { Stack } from "@mui/material";
import { useTotalInHeaderCalculator } from "@/components/pages/common/ag-grid/utils/hooks/useTotalInHeaderCalculator.hook";
import { SavingsOpportunity } from "@/services/cloudchipr.api";
import { OpportunitiesMetadataCard } from "@/components/pages/common/opportunities/components/metadata/OpportunitiesMetadataCard";
import { AiKubernetesRecommendationsTopOnes } from "@/components/pages/ai-kubernetes-recommendations/components/AiKubernetesRecommendationsTopOnes";

interface AiKubernetesRecommendationsMetadata {
  gridApi: GridApi | null;
}

export const AiKubernetesRecommendationsMetadata: FC<
  AiKubernetesRecommendationsMetadata
> = ({ gridApi }) => {
  const monthlySavings = useTotalInHeaderCalculator<SavingsOpportunity>(
    gridApi,
    (data) => data.monthly_savings,
    "sum",
  );

  return (
    <Stack direction="row" p={1} spacing={1} justifyContent="space-between">
      <Stack border={1} borderRadius={2} borderColor="grey.300" flexBasis="30%">
        <OpportunitiesMetadataCard
          title="Potential Monthly Savings"
          prefix="~"
          value={monthlySavings}
          tooltip="Potential monthly savings based on filters."
          valueColor="success.light"
        />
      </Stack>

      <AiKubernetesRecommendationsTopOnes />
    </Stack>
  );
};
